import { useWorkspaceId } from "../../workspace/useWorkspaceId";
import { useQuery } from "@tanstack/react-query";
import { useSelector } from "@tanstack/react-store";
import { useTranslation } from "react-i18next";
import { store } from "../../../store/store";
import {
    BASE_API_URL,
    HttpError,
} from "../../api/utils/useGovernmentAgencyHubAppQueryClient";
import { useHttpGovernmentAgencyHubAppHeaders } from "../../api/utils/useHttpGovernmentAgencyHubAppHeaders";
import type { KpiDTO } from "./KpiDTO";

import { getQueryStringFromParams } from "../../api/utils/paramUtils";

export function useGetKPIs() {
    const workspaceId = useWorkspaceId();
    const headers = useHttpGovernmentAgencyHubAppHeaders();
    const { t } = useTranslation();
    const filters = useSelector(
        store,
        (state) => state.taxSubmissionsSearchFilters,
    );

    const queryParams = {
        deadlineFrom: filters.deadlineFrom.getTime() || 0,
        deadlineTo: filters.deadlineTo.getTime() || 0,
    };

    const queryString = getQueryStringFromParams(queryParams);

    const query = useQuery<KpiDTO[]>({
        queryKey: ["useGetKPIs", workspaceId, queryString],
        queryFn: async () => {
            const response = await fetch(
                `${BASE_API_URL}/tenants/${workspaceId}/kpis?${queryString}`,
                {
                    headers,
                },
            );

            if (!response.ok) {
                throw new HttpError(response);
            }

            return response.json();
        },
        enabled: !!workspaceId,
        initialData: [],
        placeholderData: () => [],
        meta: {
            resourceName: t("errors.resourceName.kpis"),
        },
    });

    return query;
}
